theme.modalChart = function() {
  var ids = [];
  var buttons = document.querySelectorAll('.chart-modal-button');
  console.log
  if (!buttons.length) {
    return;
  }

  buttons.forEach(button => {
    button.addEventListener('mouseover', productMouseover);
  });

  function productMouseover(evt) {
    var el = evt.currentTarget;
    el.removeEventListener('mouseover', productMouseover);
    // No quick view on mobile breakpoint
      if (!el || !el.dataset.productId) {
        // Onboarding product, no real data
        return;
      }
      var productId = el.dataset.productId;
      var modalId = 'QuickShopHolder-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);
  }
};
function DOMready(callback) {
  if (document.readyState != 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
}
DOMready(function(){
	theme.modalChart();
});